/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const PromptPatch = core.serialization.object({
    prompt: core.serialization.string(),
});
